'use client'

// eslint-disable-next-line no-restricted-imports
import { ToastContainer, type ToastOptions } from 'react-toastify'
import { Icon } from '../icons/icon/Icon'
import { useBreakpoints } from '@/lib/device/useBreakpoint'

type CloseButtonProps = {
  closeToast: (event: React.MouseEvent<HTMLElement>) => void
}

function ToastCloseButton({ closeToast }: CloseButtonProps) {
  return (
    <button
      type="button"
      onClick={closeToast}
      aria-label="Fermer"
      className="p-2 text-current opacity-70 transition-opacity"
    >
      <Icon.X size="sm" />
    </button>
  )
}

export function ToastProvider() {
  const { isMobileWidth } = useBreakpoints({ debounceDelay: 150 })

  const toastConfig: ToastOptions = {
    position: 'top-right',
    closeOnClick: false,
    autoClose: 8000,
    closeButton: isMobileWidth ? ToastCloseButton : undefined,
  }

  return (
    <div data-react-aria-top-layer="true">
      <ToastContainer
        {...toastConfig}
        className="fixed left-auto right-2 top-2 z-toast w-full max-w-[calc(100%-2rem)] p-1 tablet:max-w-[23rem] tablet:p-0"
      />
    </div>
  )
}
